import {combineReducers} from "redux";

import {reduceRequestState, RequestState} from "@pg-mono/request-state";

import {fetchAllListsType} from "../../search/actions/fetch_search_all_action";
import {vendorSearchFormFields} from "../components/SearchVendor";
import {IVendorDetailStore, vendorDetailReducer} from "./vendor_detail_reducer";
import {IVendorListStore, vendorListReducer} from "./vendor_list_reducer";
import {IRecommendedRegionVendorsStore, vendorRecommendedVendorsReducer} from "./vendor_recommended_vendors_reducer";

export interface IVendorStore {
    list: IVendorListStore;
    detail: IVendorDetailStore;
    searchFormValues: Record<keyof typeof vendorSearchFormFields, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    fetchAllRequest: RequestState;
    recommendedRegionVendors: IRecommendedRegionVendorsStore;
}

export const vendorReducer = combineReducers({
    list: vendorListReducer,
    detail: vendorDetailReducer,
    recommendedRegionVendors: vendorRecommendedVendorsReducer,
    fetchAllRequest: reduceRequestState(fetchAllListsType)
});
import {combineReducers} from "redux";

import {reduceRequestState, RequestState} from "@pg-mono/request-state";

import {fetchAllListsType} from "../../search/actions/fetch_search_all_action";
import {vendorSearchFormFields} from "../components/SearchVendor";
import {IVendorDetailStore, vendorDetailReducer} from "./vendor_detail_reducer";
import {IVendorListStore, vendorListReducer} from "./vendor_list_reducer";
import {IRecommendedRegionVendorsStore, vendorRecommendedVendorsReducer} from "./vendor_recommended_vendors_reducer";

export interface IVendorStore {
    list: IVendorListStore;
    detail: IVendorDetailStore;
    searchFormValues: Record<keyof typeof vendorSearchFormFields, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    fetchAllRequest: RequestState;
    recommendedRegionVendors: IRecommendedRegionVendorsStore;
}

export const vendorReducer = combineReducers({
    list: vendorListReducer,
    detail: vendorDetailReducer,
    recommendedRegionVendors: vendorRecommendedVendorsReducer,
    fetchAllRequest: reduceRequestState(fetchAllListsType)
});
